import { useRef, useEffect, useState } from "react";
import { useScreenSize } from "../../hooks/useScreenSize";
import ImageCard from "./ImageCard";

interface ContentSidebarProps {
  sidebarData: {
    mass_schedule?: {
      weekday?: string;
      sunday?: string;
    };
    sanctuary_hours?: string;
  };
}

export default function ContentSidebar({ sidebarData }: ContentSidebarProps) {
  const { screenLargerThan } = useScreenSize();
  const isLarge = screenLargerThan('lg');
  const isSmall = !screenLargerThan('sm');

  const calendarFrameRef = useRef<HTMLDivElement>(null);
  const [calendarDimensions, setCalendarDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const updateDimensions = () => {
      if (calendarFrameRef.current) {
        setCalendarDimensions({
          width: calendarFrameRef.current.offsetWidth,
          height: calendarFrameRef.current.offsetHeight
        });
      }
    };

    updateDimensions();
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      padding: isLarge ? '16px' : '16px 12px',
      backgroundColor: 'var(--color-base-200)',
      width: isLarge ? '320px' : '100%',
      flexShrink: 0,
    }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: isLarge ? '1fr' : (isSmall ? '1fr' : '1fr 1fr'),
        gap: '12px',
      }}>
        <ImageCard
          backgroundImage={'https://media.gettyimages.com/id/1725905443/photo/vatican-city-vatican-cardinal-b%C3%A9chara-boutros-ra%C3%AF-the-maronite-patriarch-of-antioch-presides.jpg?s=612x612&w=gi&k=20&c=XQfFuv_paSeDhU7966eOFa_u6c4ZGqhEGFSrJ_ilMXM='}
          title="Messes"
        >
          <ImageCard.Content>
            <ImageCard.Description>
              <div style={{
                display: 'flex',
                flexDirection: 'row',
              }}>
                <div style={{ flex: 1 }}>
                  <strong style={{ fontSize: '0.75rem' }}>Lundi au Samedi</strong>
                  <h2 className={isSmall ? "text-xl" : "text-2xl"} >
                    {sidebarData?.mass_schedule?.weekday || '-'}
                  </h2>
                </div>
                <div style={{ flex: 1 }}>
                  <strong style={{ fontSize: '0.75rem' }}>Dimanche</strong>
                  <h2 className={isSmall ? "text-xl" : "text-2xl"} >
                    {sidebarData?.mass_schedule?.sunday || '-'}
                  </h2>
                </div>
              </div>
            </ImageCard.Description>
          </ImageCard.Content>
        </ImageCard>

        <ImageCard
          backgroundImage={'https://dayrna.ca/_assets/images/slider/mazar-slider-1.jpg'}
          title="Sanctuaire des Saints"
        >
          <ImageCard.Content>
            <ImageCard.Description>
              <div style={{ textAlign: 'center' }}>
                <strong style={{ fontSize: '0.75rem' }}>Lundi à Dimanche</strong>
                <h2 className={isSmall ? "text-xl" : "text-2xl"} >
                  {sidebarData?.sanctuary_hours}
                </h2>
              </div>
            </ImageCard.Description>
          </ImageCard.Content>
        </ImageCard>
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}>
        <h3 style={{
          margin: 0,
          fontSize: '1.1rem',
          fontWeight: 'bold',
          color: 'var(--color-neutral)',
        }}>
          Calendrier
        </h3>
        <div
          ref={calendarFrameRef}
          style={{
            width: '100%',
            height: isLarge ? '300px' : '350px',
            backgroundColor: 'white',
            borderRadius: '4px',
            overflow: 'hidden',
          }}
        >
          {calendarDimensions.width > 0 && (
            <iframe
              src="https://calendar.google.com/calendar/embed?src=3eca8543cc46a40dcc1f3b8f64bce471ade25b51c0bfe5b3a07cc42e6a947229%40group.calendar.google.com&ctz=America%2FNipigon&mode=AGENDA"
              style={{ border: 0 }}
              width={calendarDimensions.width}
              height={calendarDimensions.height}
            />
          )}
        </div>
      </div>
    </div>
  );
}
